import { Component, output, signal } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class Sidebar {
  // Definiamo le voci di menu
  menuItems = [
    { id: 'index', label: 'Indici', icon: 'analytics' },
    { id: 'documents', label: 'Documenti', icon: 'description', children: [
      { id: 'to-process', label: 'Da processare', icon: 'pending' },
      { id: 'processed', label: 'Processati', icon: 'check_circle' },
      { id: 'error', label: 'In errore', icon: 'error' }
    ]},
    { id: 'web-sites', label: 'Siti web', icon: 'language' }
  ];

  // Signal per tenere traccia del tasto attivo internamente (opzionale ma utile per i CSS)
  activeId = signal<string>('index');

  // L'evento che la Home ascolterà
  viewSelected = output<string>();

  selectView(id: string) {
   // 1. Se clicco su 'documents', trasformo l'id in 'to-process'
   const targetId = id === 'documents' ? 'to-process' : id;
   console.log('TARGET ID = ',targetId)
    
   // 2. Aggiorno il segnale per il CSS (attiva l'active e l'apertura del menu)
   this.activeId.set(targetId);
   
   // 3. Comunico alla Home la vista effettiva
   this.viewSelected.emit(targetId);
  }

  isChildActive(item: any): boolean {
    if (!item.children) return false;
    return item.children.some((sub: any) => sub.id === this.activeId());
  }
}